import React, { useState } from 'react';
import { Users, UserPlus, Building2 } from 'lucide-react';
import TabPageLayout from 'modules/swiftboard/components/TabPageLayout';
import Country from './country/Country';
import TradeOfWork from './trade-of-work/TradeOfWork';
import Designation from './designation/DesignationDirectory';
import BusinessType from './bussiness-type/BusinessType';
import useUrlTab from "modules/swiftboard/components/useUrlTab";
 
const BusinessDirectory = () => {

  const [activeTab, setActiveTab] = useUrlTab(["designation", "trade-of-work", "country", "business-type"]);
  const [tabCounts, setTabCounts] = useState({});

  const setTabCount = (tabId) => (count) =>
    setTabCounts((prev) => (prev[tabId] === count ? prev : { ...prev, [tabId]: count }));

  const centralDirectoryTabs = [
    {
      id: 1,
      label: 'Designation',
      icon: <Users size={18} />,
    },
    {
      id: 2,
      label: 'Trade Of Work',
      icon: <UserPlus size={18} />,
    },
    {
      id: 3,
      label: 'Country',
      icon: <Users size={18} />,
    },
    {
      id: 4,
      label: 'Business Type',
      icon: <Building2 size={18} />,
    }
  ].map((tab, index) => ({
    ...tab,
    badge:
      index === activeTab && tabCounts[tab.id] !== undefined
        ? { count: tabCounts[tab.id], compact: true }
        : undefined,
  }));

  const handleTabChange = (index, tab) => {
    setActiveTab(index);
  };


 

  return (
    <TabPageLayout
      tabs={centralDirectoryTabs}
      activeTab={activeTab}
      onTabChange={handleTabChange}
    >
      {activeTab === 0 && <Designation onTotalCountChange={setTabCount(1)} />}
      {activeTab === 1 && <TradeOfWork onTotalCountChange={setTabCount(2)} />}
      {activeTab === 2 && <Country onTotalCountChange={setTabCount(3)} />}
      {activeTab === 3 && <BusinessType onTotalCountChange={setTabCount(4)} />}
    </TabPageLayout>
  );
};

export default BusinessDirectory;